import { t } from "@lingui/macro";
import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { MarkdownDisplay } from "@whoosh/design-system/src/components/display/MarkdownDisplay/MarkdownDisplay";
import { Box, Text } from "@whoosh/design-system/src/components/primitive";
import { getNounOverride } from "@whoosh/utilities/src/FormatNounOverride/getNounOverride";

import { BookingPolicy_Booking$key } from "./__generated__/BookingPolicy_Booking.graphql";

type Props = {
  bookingRef: BookingPolicy_Booking$key | null;
};

export const BookingPolicy = ({ bookingRef }: Props) => {
  const data = useFragment(BookingPolicyFragmentString, bookingRef);
  const isLesson = data?.__typename === "LessonBooking";
  const facility = data?.startSlot?.agenda?.facility;

  const bookingPolicy = facility?.bookingPolicy ?? "";
  const lessonsPolicy = facility?.lessonsPolicy ?? "";

  const showBookingPolicy = Boolean(
    facility?.showBookingPolicy && bookingPolicy
  );
  const showLessonsPolicy = Boolean(
    facility?.showLessonsPolicy && lessonsPolicy
  );

  const shouldShow = isLesson ? showLessonsPolicy : showBookingPolicy;
  if (!shouldShow) return null;

  const lessonNoun = getNounOverride(
    facility?.copyOverrides?.lesson?.singular,
    t`Lesson`
  );

  const title = isLesson ? `${lessonNoun} ${t`Policy`}` : t`Booking Policy`;
  const markdown = isLesson ? lessonsPolicy : bookingPolicy;

  return (
    <Box padding={5} gap={4} backgroundColor="surface-primary">
      <Text variant="mainHeading" color="text-primary">
        {title}
      </Text>
      <MarkdownDisplay markdown={markdown} />
    </Box>
  );
};

const BookingPolicyFragmentString = graphql`
  fragment BookingPolicy_Booking on Booking {
    id
    __typename
    startSlot {
      agenda {
        facility {
          bookingPolicy
          showBookingPolicy
          lessonsPolicy
          showLessonsPolicy
          copyOverrides {
            lesson {
              singular
            }
          }
        }
      }
    }
  }
`;
